export default __webpack_public_path__ + "static/media/WWYK-sharepass.4ea86746.gif";